
import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { useReactToPrint } from "react-to-print";
import { Search } from 'lucide-react';
import classes from "./FinancialSummaryDetailed.module.css";
import plus from "../../../Assets/plus.svg"
import run from "../../../Assets/run.svg"
import MailLogo from "../../../Assets/mail.svg"
import PrintLogo from "../../../Assets/print.svg"
import DownloadLogo from "../../../Assets/down.svg"
import BackLogo from "../../../Assets/back.svg"
import RotatingLogo from '../../../Assets/rotating-logo.png'
import EyeIcon from "../../../Assets/new-eye.svg"
import DeleteIcon from "../../../Assets/new-delete.svg"
import PencilIcon from "../../../Assets/pencil.svg"
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { Spinner, Badge, Button, Modal, Form } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import HeaderNav from "../../Accoungting/HeaderNav/HeaderNav";
import axios from "axios";
import { BASE_URL } from "../../../Components/Styles/API/API";
import { useLocation, useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import download from "../../../Assets/download1.svg"
import upload from "../../../Assets/upload.svg"
import logo from "../../../Assets/rotating-logo.png";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Multiselect from "../../../Components/Multiselect";
import ExcelLogo from "../../../Assets/excel.png"
import PdfLogo from "../../../Assets/pdf.png"
import * as XLSX from 'xlsx'; // Import xlsx library
import { saveAs } from 'file-saver';
import jsPDF from "jspdf";
import "jspdf-autotable";






const FinancialPositionDetailed = () => {
  const location = useLocation();
const [noData, setNoData] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectOptions, setSelectOptions] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [load, setLoad] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [tableData3, setTableData3] = useState([]);
  const [tableData4, setTableData4] = useState([]);
  const [accounts, setAccounts] = useState([]);
    const [provin, setProvin] = useState("");
    const [regio, setRegio] = useState("");
    const [contin, setContin] = useState("");
  const [selectedProvince, setSelectedProvince] = useState('');
  const [selectedRegion, setSelectedRegion] = useState('');
  const [selectedContinent, setSelectedContinent] = useState('');
  const [tableData45, setTableData45] = useState([]);
  const [totalDebit, setTotalDebit] = useState('');
  const [totalCredit, setTotalCredit] = useState('');
  const [allAccounts, setAllAccounts] = useState([]);
  const [fetchingLoading, setFetchingLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedBank, setSelectedBank] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [searchedResult, setSearchedResult] = useState([]);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [bearer, setBearer] = useState('');
  const [user, setUser] = useState('');
  const [error, setError] = useState(null);
  const [entriesPerPage, setEntriesPerPage] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalEntries, setTotalEntries] = useState("");
  const [loanCode, setLoanCode] = useState("");
  const [loanDescription, setLoanDescription] = useState("");
  const [selectedReportTo, setSelectedReportTo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [savingsLoading, setSavingsLoading] = useState(false);
  const [show1, setShow1] = useState(false);
  const [cashbook, setCashbook] = useState([]);
  const [tableData, setTableData] = useState([]);
   const [selectedIds, setSelectedIds] = useState([]);
  const navigate = useNavigate();
  const [benLoading, setBenLoading] = useState(false);
  const [statLoading, setStatLoading] = useState(false);
  const [stat, setStat] = useState([]);
  const [overallTotal, setOverallTotal] = useState(0);
  const [currentMonth, setCurrentMonth] = useState("");
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedEndDate, setSelectedEndDate] = useState('');
  const [inputss, setInputss] = useState([]);
  const [loadings, setLoadings] = useState(false);
  const [continent, setContinent] = useState('');
  const [region, setRegion] = useState('');
  const [province, setProvince] = useState('');
  const [admin, setAdmin] = useState('');
    const [usert, setUsert] = useState("");

  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value1 = await localStorage.getItem('tobi');
      const current = await localStorage.getItem('currentMonth');
      const admins = await localStorage.getItem('admin');
      // const saved = localStorage.getItem("cashbook_preview");
      const continentName = await localStorage.getItem('continent');
      const regionName = await localStorage.getItem('region');
      const provinceName = await localStorage.getItem('province');
 const usertype = await localStorage.getItem('userType');
       const provinceid = await localStorage.getItem('provinceID');
      const continentid = await localStorage.getItem('continentID');
      const regionid = await localStorage.getItem('regionID');
      
      if (value !== null) {
        setBearer(value);
      }
       if (provinceid !== null) {
        setSelectedProvince(provinceid);
      }
      if (continentid !== null) {
        setSelectedContinent(continentid);
      }
      if (regionid !== null) {
        setSelectedRegion(regionid);
      }
      if (usertype !== null) {
        setUsert(usertype);
      }
      // if (saved) {
      //   setCashbook(JSON.parse(saved));
      // }

      if (value1 !== null) {
        setUser(value1);
      }
      if (current !== null) {
        console.log(current);
        const date = new Date(current);

        setCurrentMonth(date);

        const startOfDateRange = new Date(1900, 0, 1);

        const endOfDateRange = new Date(date.getFullYear(), date.getMonth() + 1, 0);

        // Format date function as 'YYYY-MM-DD'
        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        };

        setMinDate(formatDate(startOfDateRange));
        setMaxDate(formatDate(endOfDateRange));

        console.log("Date Range:", formatDate(startOfDateRange), "to", formatDate(endOfDateRange));
      }
      if (admins !== null) {
        setAdmin(admins);
      }
      if (continentName !== null) {
        setContinent(continentName);
      }
      if (regionName !== null) {
        setRegion(regionName);
      }
      if (provinceName !== null) {
        setProvince(provinceName);
      }
      if (provinceid !== null) {
        setProvin(provinceid);
      }
      if (continentid !== null) {
        setContin(continentid);
      }
      if (regionid !== null) {
        setRegio(regionid);
      }
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };


const handleChange = (selected) => {
    // Check if "Select All" was clicked
    if (selected?.some((opt) => opt.value === "ALL")) {
      if (selectedOptions.length === allAccounts.length) {
        // If all are already selected -> unselect all
        setSelectedOptions([]);
        handleBank([]); // pass empty back
      } else {
        // Otherwise select everything
        setSelectedOptions(allAccounts);
        handleBank(allAccounts);
      }
    } else {
      setSelectedOptions(selected || []);
      handleBank(selected || []);
    }
  };

  // prepend "Select All" option
  const optionsWithAll = [{ value: "ALL", label: "Select All" }, ...allAccounts];





  const handleShow1 = (loan) => {
    setLoanCode(loan.code);
    setLoanDescription(loan.description);
    setSelectedReportTo(loan.reportTo);
    setShow1(true);
  };

  const handleClose1 = () => setShow1(false);


  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const handleCustomers = async () => {
    setBenLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/fetch-pending-sales-invoice-paginated?page=${currentPage}`, { headers });
      const results = response.data?.data?.data;
      const resultx = response.data?.data?.total;
      setTotalEntries(resultx);
      setTableData(results);
      console.log(results, "From Remittane")
      const total = response.data?.data?.last_page || 1;
      setTotalPages(total);

    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response?.data && error.response?.data.message) {
          if (typeof error.response?.data.message === 'string') {
            errorMessage = error.response?.data.message;
          } else if (Array.isArray(error.response?.data.message)) {
            errorMessage = error.response?.data.message.join('; ');
          } else if (typeof error.response?.data.message === 'object') {
            console.log(errorMessage);
            setError(errorMessage)
          }
        }
        setTableData([]);
      }
    } finally {
      setBenLoading(false);
    }

  };

  useEffect(() => {
    if (bearer) {
      handleCustomers();
    }
  }, [bearer, currentPage]);

const fetchAccounts = async () => {
  setSavingsLoading(true);

  try {
    const params = {
      start_date: selectedDate,
      end_date: selectedEndDate,
    };

    if (usert === "2") {
      params.continent_id = contin;
    } else if (usert === "3") {
      params.region_id = regio;
    } else if (usert === "4") {
      params.province_id = provin;
    }

    const response = await axios.get(
      `${BASE_URL}/reports/financial-position`,
      {
        params,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${bearer}`,
        },
      }
    );

    const records = response.data?.data?.records || [];
    const data = response.data?.data || [];

    setAccounts(records);
    setInputss(data);

    console.log(records);
  } catch (error) {
    if (error.response?.status === 401) {
      navigate("/login");
    } else {
      console.log(error.response?.data?.message);
    }
  } finally {
    setSavingsLoading(false);
  }
};


 

  const getFiscalMonth = (transactionDate) => {
  const date = new Date(transactionDate);
  const calendarMonth = date.getMonth(); // 0-11
  // Fiscal month: Sep = 0, Oct = 1, ..., Aug = 11
  const fiscalMonth = (calendarMonth + 4) % 12 + 1; // Shift so Sep=1, Aug=12
  return fiscalMonth.toString().padStart(2, '0');
};


  

  const fetchAccountss = async () => {
    console.log(headers)
    setLoadings(true);

    try {
      const response = await axios.get(`${BASE_URL}/account`, { headers });

      const CustomOption = (props) => {
        const { data, innerRef, innerProps } = props;
        return (
          <div ref={innerRef} {...innerProps}>
            <span style={{ color: 'blue' }}>{data?.gl_code}</span>
            {' - '}
            <span style={{ color: 'red', fontWeight: 'bold' }}>{data?.gl_name}</span>
          </div>
        );
      };

      const allAccts = response.data?.data;
      const opt1 = allAccts.map((item) => ({
        label: `${item.gl_code} - ${item.gl_name}`,
        value: item.id,
      }));
      setAllAccounts(opt1);

      //   console.log(allAccts, "All Accounts");
    } catch (error) {
      const errorStatus = error.response?.data.message;
      console.error(errorStatus);
    } finally {
      setLoadings(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchAccountss();
    }
  }, [bearer]);


 const handleSelectionChange = (ids) => {
    console.log("Selected IDs:", ids);
    setSelectedIds(ids);
  };



  function formatDates(dateString) {
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())}`;
    return formattedDate;
  }

  function padZero(num) {
    return num < 10 ? `0${num}` : num;
  }

  const handlePrevPage = () => {
    setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
  };

  const formattedTotalEntries = totalEntries.toLocaleString();

  const fetchStat = async () => {
    setStatLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/customer/total-customers`, { headers });
      const stas = response.data?.data;

      setStat(stas);

    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            console.log(errorMessage);
          }
        }
        setStat([]);
      }
    } finally {
      setStatLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchStat();

    }
  }, [bearer]);

  const formatStat = (value) => {
    if (value == null) return "";

    if (value >= 1000 && value < 1000000) {
      const rounded = value / 1000;
      // If divisible by 1000 exactly, no decimals (30k)
      if (value % 1000 === 0) {
        return `${rounded}k`;
      }
      // Else show 2 decimals (30.01k)
      return `${rounded.toFixed(2)}k`;
    }

    if (value >= 1000000) {
      const rounded = value / 1000000;
      if (value % 1000000 === 0) {
        return `${rounded}M`;
      }
      return `${rounded.toFixed(2)}M`;
    }

    // smaller than 1000 → just locale string with commas
    return value.toLocaleString("en-US");
  };

  const isSearching = searchTerm.trim() !== "" && searchedResult.length > 0;
  const handleDateChange1 = (event) => {
    setSelectedEndDate(event.target.value);
  };

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  const handleBank = (selectedOption) => {
    setSelectedBank(selectedOption);
  };

  const handleCreate = () => {

  }

  const fetchContinents = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/continents`, { headers });
      const results = response.data?.data;

      const options = results.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      // setCustomers(results);
      setSelectOptions(options);
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setCustomers([]);
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    if (bearer) {
      fetchContinents();
    }
  }, [bearer]);



  const fetchSubContinents = async () => {
    setLoad(true);
    try {
      const response = await axios.get(`${BASE_URL}/regions`, { headers });

      // console.log(response);
      const subCont = response.data?.data?.regions;
      const options1 = subCont.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      setTableData3(options1);
      // console.log(results);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            errorMessage = JSON.stringify(error.response.data.message);
          }
        }
        setTableData3([]);
      }
    } finally {
      setLoad(false);
    }
  };

  const fetchSubRegion = async () => {
    setLoad(true);
    try {
      const response = await axios.get(`${BASE_URL}/regions/getprovincesregion?region_id=${selectedRegion}`, { headers });

      // console.log(response);
      const subCont1 = response.data?.data;
      const options2 = subCont1.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      setTableData4(options2);
      console.log(options2);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            errorMessage = JSON.stringify(error.response.data.message);
          }
        }
        setTableData3([]);
      }
    } finally {
      setLoad(false);
    }
  };
  const fetchProvince = async () => {
    setLoad(true);
    try {
      const response = await axios.get(`${BASE_URL}/provinces`, { headers });

      // console.log(response);
      const subCont15 = response.data?.data.provinces;
      const options25 = subCont15.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      setTableData45(options25);
      console.log(response);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            errorMessage = JSON.stringify(error.response.data.message);
          }
        }
        setTableData3([]);
      }
    } finally {
      setLoad(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchSubContinents();
    }
  }, [bearer]);

  useEffect(() => {
    if (bearer && selectedRegion) {
      fetchSubRegion(selectedRegion);
    }
  }, [bearer, selectedRegion]);

  useEffect(() => {
    if (bearer) {
      fetchProvince();
    }
  }, [bearer]);

  const handleContinentChange = (selectedOption) => {
    setSelectedContinent(selectedOption.value);
    setSelectedRegion('');
    setSelectedProvince('');
  };


  const handleRegionChange = (selectedOption) => {
    setSelectedRegion(selectedOption.value)
  }

  const handleProvinceChange = (selectedOption) => {
    setSelectedProvince(selectedOption.value)
  }


  function formatDate(dateString) {
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())} ${padZero(date.getHours())}:${padZero(date.getMinutes())} ${date.getHours() >= 12 ? 'PM' : 'AM'}`;
    return formattedDate;
  }

  function padZero(num) {
    return num < 10 ? `0${num}` : num;
  }

  useEffect(() => {
        if (accounts) {
            const firstTotal = accounts?.total || 0;
            const secondTotal = inputss?.total || 0;

            setTotalDebit(firstTotal);
            setTotalCredit(secondTotal);
            setOverallTotal(firstTotal - secondTotal); 
        }
    }, [accounts]);

const tableRef = useRef(null);

const handlePrint = () => {
  window.print();
};

const totalCombined = [accounts[1], accounts[2]].reduce((sum, item) => {
  return sum + item?.categories.reduce((catSum, category) => catSum + parseFloat(category.total), 0);
}, 0);

const totalcCombined = [accounts[1], accounts[2]].reduce((sum, item) => {
  return sum + item?.categories.reduce((catSum, category) => catSum + parseFloat(category.cTotal), 0);
}, 0);

const exportToExcel = async () => {
  // 1. Safety Check
  if (!accounts || accounts.length === 0) {
    console.log("No data available to export");
    return;
  }

  const sheetData = [];
  const fmt = (val) => parseFloat(val || 0); // Helper for numbers

  // --- HEADERS ---
  sheetData.push(["The Redeemed Christian Church Of God"]);
  sheetData.push([province === 'undefined' ? admin : province]);
  sheetData.push(["Statement of Financial Position - Detail Report"]);
  sheetData.push([`Period: ${inputss?.start_date || '-'} to ${inputss?.end_date || '-'}`]);
  sheetData.push([""]); 

  // Table Headers
  sheetData.push(["Description", "", "", `Current Amount`, "", `Comparative Amount`]);
  sheetData.push(["", "", "", "N'000", "", "N'000"]);

  // --- NESTED DATA LOOP ---
  accounts.forEach((mainItem) => {
    // 1. Main Account Header (e.g., ASSETS)
    sheetData.push([mainItem.description.toUpperCase(), "", "", "", "", ""]);

    if (mainItem.categories) {
      mainItem.categories.forEach((category) => {
        // 2. Category Header (e.g., Fixed Assets)
        sheetData.push([`   ${category.description}`, "", "", "", "", ""]);

        // 3. Postings (e.g., Land)
        if (category.postings) {
          category.postings.forEach((posting) => {
            sheetData.push([
              `      ${posting.name}`, // Indent
              "", 
              "", 
              fmt(posting.amount), 
              "", 
              fmt(posting.cAmount)
            ]);
          });
        }

        // Category Total Row
        sheetData.push([
          `   TOTAL ${category.description.toUpperCase()}`,
          "",
          "",
          fmt(category.total),
          "",
          fmt(category.cTotal)
        ]);

        sheetData.push([""]); // Spacer
      });
    }
  });

  // --- GRAND TOTAL ---
  // Replicating the label logic from your JSX
  const footerLabel = accounts.length > 2 
    ? `TOTAL ${accounts[1]?.description.toUpperCase()} & ${accounts[2]?.description.toUpperCase()}` 
    : "GRAND TOTAL";

  sheetData.push([
    footerLabel,
    "",
    "",
    fmt(totalCombined),
    "",
    fmt(totalcCombined)
  ]);

  // --- SIGNATURES ---
  sheetData.push([""]);
  sheetData.push([""]);
  sheetData.push(["These Financial Statements were approved by the Governing Council at a meeting held on __________________ and were signed on its behalf by:"]);
  sheetData.push([""]);
  sheetData.push(["", "National Overseer", "", "", "National Treasurer"]);

  // --- GENERATE FILE ---
  const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "FinancialPositionDetail");

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const file = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(file, `Financial_Position_Detail_${inputss?.end_date}.xlsx`);
};

const exportToPDF = () => {
  if (!accounts || accounts.length === 0) return;

  const doc = new jsPDF("p", "mm", "a4");
  const pageWidth = doc.internal.pageSize.getWidth();

  const formatCurrency = (val) => {
    return parseFloat(val || 0).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  // --- Header Section ---
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text("The Redeemed Christian Church Of God", pageWidth / 2, 15, { align: "center" });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(12);
  doc.text(province === 'undefined' ? admin : province || "", pageWidth / 2, 22, { align: "center" });
  doc.text("Statement of Financial Position - Detail Report", pageWidth / 2, 28, { align: "center" });

  doc.setFontSize(10);
  doc.text(
    `Period: ${inputss?.start_date || "--"} to ${inputss?.end_date || "--"}`,
    pageWidth / 2,
    34,
    { align: "center" }
  );

  // --- Prepare Flattened Rows ---
  const rows = [];

  accounts.forEach((mainItem) => {
    // 1. Main Header (ASSETS)
    rows.push({
      description: mainItem.description.toUpperCase(),
      current: "",
      comparative: "",
      type: "MAIN_HEADER"
    });

    if (mainItem.categories) {
      mainItem.categories.forEach((category) => {
        // 2. Category Header (Fixed Assets)
        rows.push({
          description: category.description,
          current: "",
          comparative: "",
          type: "CAT_HEADER"
        });

        // 3. Postings
        if (category.postings) {
          category.postings.forEach((posting) => {
            rows.push({
              description: posting.name,
              current: formatCurrency(posting.amount),
              comparative: formatCurrency(posting.cAmount),
              type: "POSTING"
            });
          });
        }

        // 4. Category Total
        rows.push({
          description: `TOTAL ${category.description.toUpperCase()}`,
          current: formatCurrency(category.total),
          comparative: formatCurrency(category.cTotal),
          type: "CAT_TOTAL"
        });

        rows.push({ description: "", type: "SPACER" });
      });
    }
  });

  // --- Grand Total ---
  const footerLabel = accounts.length > 2 
    ? `TOTAL ${accounts[1]?.description.toUpperCase()} & ${accounts[2]?.description.toUpperCase()}` 
    : "GRAND TOTAL";

  rows.push({
    description: footerLabel,
    current: formatCurrency(totalCombined),
    comparative: formatCurrency(totalcCombined),
    type: "GRAND_TOTAL"
  });

  // --- Draw Table ---
  doc.autoTable({
    head: [
      [
        { content: "Description", styles: { halign: "left" } },
        { content: "Current Amount", styles: { halign: "right", fontStyle: "bold" } },
        { content: "Cummulative Amount", styles: { halign: "right", fontStyle: "bold" } }
      ]
    ],
    body: rows.map(r => [r.description, r.current, r.comparative]),
    startY: 40,
    theme: "plain",
    styles: { fontSize: 9, cellPadding: 3 },
    columnStyles: {
      0: { cellWidth: 90 }, 
      1: { cellWidth: 50, halign: "right" }, 
      2: { cellWidth: 50, halign: "right" }
    },
    didParseCell: (data) => {
      const rowData = rows[data.row.index];
      if (!rowData) return;

      // Style Main Headers (ASSETS)
      if (rowData.type === "MAIN_HEADER") {
        data.cell.styles.fontStyle = "bold";
        data.cell.styles.fontSize = 10;
        // Logic to simulate underline if needed, or rely on bold formatting
      } 
      // Style Category Headers
      else if (rowData.type === "CAT_HEADER") {
        data.cell.styles.fontStyle = "bold";
        data.cell.styles.cellPadding = { left: 5, top: 2, bottom: 2 };
      } 
      // Style Postings (Indented)
      else if (rowData.type === "POSTING") {
        data.cell.styles.cellPadding = { left: 10, top: 2, bottom: 2 };
      } 
      // Style Category Totals
      else if (rowData.type === "CAT_TOTAL") {
        data.cell.styles.fontStyle = "bold";
        data.cell.styles.cellPadding = { left: 5, top: 2, bottom: 2 };
        
        if (data.column.index > 0) {
          // Colors matching your UI
          if (data.column.index === 1) data.cell.styles.fillColor = [242, 247, 255]; // #F2F7FF
          if (data.column.index === 2) data.cell.styles.fillColor = [230, 236, 245]; // #90AAD6 approx
          
          // Borders
          data.cell.styles.lineWidth = { top: 0.1, bottom: 0.1 };
          data.cell.styles.lineColor = [0, 0, 0];
        }
      }
      // Style Grand Total
      else if (rowData.type === "GRAND_TOTAL") {
        data.cell.styles.fontStyle = "bold";
        data.cell.styles.fontSize = 10;
        if (data.column.index > 0) {
          if (data.column.index === 1) data.cell.styles.fillColor = [242, 247, 255]; 
          if (data.column.index === 2) data.cell.styles.fillColor = [230, 236, 245];
          
          data.cell.styles.lineWidth = { top: 0.1, bottom: 0.1 };
          data.cell.styles.lineColor = [0, 0, 0];
        }
      }
    }
  });

  // --- Footer Signatures ---
  const finalY = doc.lastAutoTable.finalY + 15;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  const text = "These Financial Statements were approved by the Governing Council at a meeting held on __________________ and were signed on its behalf by:";
  const splitText = doc.splitTextToSize(text, pageWidth - 30);
  doc.text(splitText, 15, finalY);

  doc.setFont("helvetica", "bold");
  doc.text("National Overseer", 40, finalY + 25);
  doc.text("National Treasurer", pageWidth - 80, finalY + 25);

  doc.save("Financial_Position_Detail.pdf");
};


  return (
    <div style={{ backgroundColor: "#f9f9f9", minHeight: "100vh" }}>
      <HeaderNav />

      <div className={classes.topContainer}>
         <div className={classes.backTxt}>
          <img src={BackLogo} alt="back" className={classes.iconBtn} onClick={ () => navigate(-1)} />
          <div className={classes.bckText}>
            <h3 className={classes.topText}>Statement of Financial Position - Detail</h3>
            {/* <p className={classes.prgText}>Account Activity Report between the period of {inputss?.start_date
    ? new Date(inputss?.start_date).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : "--"} to {inputss?.end_date
    ? new Date(inputss?.end_date).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : "--"}</p> */}
          </div>
          
        </div>
        <div style={{ marginTop: 12 }} />
        <div className={classes.topNavBars}>
          <div className={classes.filterRow}>
            {/* Left side: Inputs */}
            <div className={classes.filterInputs}>
              {/* Account */}
              <div className={classes.inlineField}>
                 {admin === "Regional Accountant" && (
                                              <div className={classes.inlineField}>
                                                <label className={classes.inlineLabel}>Provinces:</label>
                                                <Select
                                                  onChange={handleProvinceChange}
                                                  options={tableData45}
                                                  menuPortalTarget={document.body}
                                                  styles={{
                                                    container: (provided) => ({
                                                      ...provided,
                                                      width: 200, // ✅ fixed width
                                                      fontSize: 14, // applies to the wrapper
                                                    }),
                                                    control: (provided) => ({
                                                      ...provided,
                                                      minHeight: "36px",
                                                      fontSize: 14, // ✅ font size inside control
                                                    }),
                                                    singleValue: (provided) => ({
                                                      ...provided,
                                                      fontSize: 14, // ✅ selected value text
                                                    }),
                                                    option: (provided, state) => ({
                                                      ...provided,
                                                      fontSize: 14, // ✅ dropdown option text
                                                      backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                                                      color: "#111827",
                                                    }),
                                                    menu: (provided) => ({
                                                      ...provided,
                                                      maxHeight: "300px",
                                                      maxWidth: "200px",
                                                      overflowY: "auto",
                                                      fontSize: 14, // ✅ font size in menu
                                                    }),
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                  }}
                                                  className={classes.inlineSelect}
                                                />
                                
                                              </div>
                                              )}
                
                
                                              {admin === "Continental Accountant" && (
                                                <div style={{display: "flex", gap: 20}}>
                                                <div className={classes.inlineField}>
                                                <label className={classes.inlineLabel}>Region:</label>
                                                <Select
                                                  onChange={handleRegionChange}
                                                  options={tableData3}
                                                  menuPortalTarget={document.body}
                                                  styles={{
                                                    container: (provided) => ({
                                                      ...provided,
                                                      width: 200, // ✅ fixed width
                                                      fontSize: 14, // applies to the wrapper
                                                    }),
                                                    control: (provided) => ({
                                                      ...provided,
                                                      minHeight: "36px",
                                                      fontSize: 14, // ✅ font size inside control
                                                    }),
                                                    singleValue: (provided) => ({
                                                      ...provided,
                                                      fontSize: 14, // ✅ selected value text
                                                    }),
                                                    option: (provided, state) => ({
                                                      ...provided,
                                                      fontSize: 14, // ✅ dropdown option text
                                                      backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                                                      color: "#111827",
                                                    }),
                                                    menu: (provided) => ({
                                                      ...provided,
                                                      maxHeight: "300px",
                                                      maxWidth: "200px",
                                                      overflowY: "auto",
                                                      fontSize: 14, // ✅ font size in menu
                                                    }),
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                  }}
                                                  className={classes.inlineSelect}
                                                />
                                
                                              </div>
                
                                              <div className={classes.inlineField}>
                                                <label className={classes.inlineLabel}>Province:</label>
                                                <Select
                                                  onChange={handleProvinceChange}
                                                  options={tableData4}
                                                  menuPortalTarget={document.body}
                                                  styles={{
                                                    container: (provided) => ({
                                                      ...provided,
                                                      width: 200, // ✅ fixed width
                                                      fontSize: 14, // applies to the wrapper
                                                    }),
                                                    control: (provided) => ({
                                                      ...provided,
                                                      minHeight: "36px",
                                                      fontSize: 14, // ✅ font size inside control
                                                    }),
                                                    singleValue: (provided) => ({
                                                      ...provided,
                                                      fontSize: 14, // ✅ selected value text
                                                    }),
                                                    option: (provided, state) => ({
                                                      ...provided,
                                                      fontSize: 14, // ✅ dropdown option text
                                                      backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                                                      color: "#111827",
                                                    }),
                                                    menu: (provided) => ({
                                                      ...provided,
                                                      maxHeight: "300px",
                                                      maxWidth: "200px",
                                                      overflowY: "auto",
                                                      fontSize: 14, // ✅ font size in menu
                                                    }),
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                  }}
                                                  className={classes.inlineSelect}
                                                />
                                
                                              </div>
                                              </div>
                                              )}
                {/* <label className={classes.inlineLabel}>Account:</label>
                <Multiselect options={allAccounts} onChange={handleSelectionChange}/> */}
              {/* <Select
  isMulti
  value={selectedOptions}
  onChange={handleChange}
  options={optionsWithAll}
  menuPortalTarget={document.body}
  styles={{
    container: (provided) => ({
      ...provided,
      width: 200,
      fontSize: 14,
    }),
    control: (provided) => ({
      ...provided,
      minHeight: "36px",
      maxHeight: "36px",       // ✅ lock the height
      fontSize: 12,
      overflow: "hidden",
    }),
    valueContainer: (provided) => ({
      ...provided,
      maxHeight: "36px",       // ✅ fix container height
      overflowY: "auto",       // ✅ scroll inside instead of growing
    }),
    multiValue: (provided) => ({
      ...provided,
      fontSize: 12,
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: 12,
      backgroundColor: state.isFocused ? "#f1f5f9" : "white",
      color: "#111827",
    }),
    menu: (provided) => ({
      ...provided,
      maxHeight: "300px",
      maxWidth: "200px",
      overflowY: "auto",
      fontSize: 12,
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  }}
/> */}


              </div>

              {/* Start Date */}
              <div className={classes.inlineField}>
                <label className={classes.inlineLabel}>Start Date:</label>
                <input
                  className="form-control"
                  type="date"
                  onChange={handleDateChange}
                  value={selectedDate}
                  style={{fontSize: 14}}
                  min={minDate}
                  max={maxDate}
                  required
                />
              </div>

              {/* End Date */}
              <div className={classes.inlineField}>
                <label className={classes.inlineLabel}>End Date:</label>
                <input
                  className="form-control"
                  type="date"
                  onChange={handleDateChange1}
                  value={selectedEndDate}
                  min={minDate}
                   style={{fontSize: 14}}
                  max={maxDate}
                  required
                />
              </div>
              <button className={classes.loanBtn} onClick={fetchAccounts}> <img src={run} alt="run-report" /> Run Report </button>
            </div>

            {/* Right side: 3 icons */}
            
          </div>


        </div>
        <div style={{ marginTop: 24 }} />
       
        <div  className={classes.tableContainer}>
         {accounts.length  === 0 ? (
             <div
               style={{
                 textAlign: "center",
                 padding: "40px",
                 fontSize: "18px",
                 color: "#374151",
               }}
             >
               <p>No data to display</p>
             </div>
           ) : (
             <>
               <div className={classes.sideTools}>
                 {accounts?.length > 0 && (
                   <div className={classes.filterIcons}>
                     <img
                       src={MailLogo}
                       alt="icon1"
                       className={classes.iconBtns}
                       onClick={() => console.log("icon1")}
                     />
                     <img
                       onClick={() => handlePrint()}
                       src={PrintLogo}
                       alt="icon2"
                       className={classes.iconBtns}
                     />
                      <img
              onClick={() => exportToExcel()}
              src={ExcelLogo}
              alt="icon3"
              className={classes.iconBtns}
            />
            <img
              onClick={() => exportToPDF()}
              src={PdfLogo}
              alt="icon3"
              className={classes.iconBtns}
            />
                   </div>
                 )}
               </div>
          <div className={classes.cntrTable}>
            <h1 className={classes.cntrTxt}>The Redeemed Christian Church Of God</h1>
             <p className={classes.cntrTxt12}>{province === 'undefined' ? admin : province}</p>
              <p className={classes.cntrTx122}>Statement of Financial Position - Detail Report
                       between the period of {" "} {selectedDate
                         ? new Date(selectedDate).toLocaleDateString("en-US", {
                             year: "numeric",
                             month: "long",
                             day: "numeric",
                           })
                         : "--"} to {" "}
                       {selectedEndDate
                         ? new Date(selectedEndDate).toLocaleDateString("en-US", {
                             year: "numeric",
                             month: "long",
                             day: "numeric",
                           })
                         : "--"}
                     </p>
            {/* <p className={classes.cntrTx1}>Activi</p> */}
            {/* <p className={classes.cntrTx2}>
  For the period ended{" "}
  {inputss?.end_date
    ? new Date(inputss?.end_date).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : "--"}
</p> */}

          </div>
 <table style={{ width: "100%", borderCollapse: "collapse", marginTop: 20 }}>
     
            <thead >
              <th style={{paddingBottom: 20}}>Description</th>
              <th></th>
              <th></th>
              {/* <th></th> */}
              <th style={{textAlign: "right", fontSize: 14}}>Current Amount</th>
              <th style={{width: 20}}></th>
              <th style={{textAlign: "right", fontSize: 14}}>Cummulative Amount</th>
              </thead>
         {/* <tbody>
           {accounts && accounts.map((item, index) => {
                        return (
                            <React.Fragment key={index}>
                               
                                <tr>
                                    <th style={{ textDecoration: "underline", fontSize: 14 }} colSpan={4}>{item.description.toUpperCase()}</th>
                                </tr>

                              
                                {item.cat_accounts?.map((category, catIndex) => (
                                    <React.Fragment key={catIndex}>
                                     
                                        <tr>
                                            <th style={{ textDecoration: "underline", paddingLeft: 20, fontSize: 14 }} colSpan={4}>{category.description}</th>
                                        </tr>
                                        {category.postings.map((posting, postIndex) => (
                                            <tr key={postIndex}>
                                                <td style={{ paddingLeft: 40, fontSize: 12 }}>{posting.name}</td>
                                                <td></td>
                                                <td style={{ textAlign: "right", backgroundColor: "#F2F7FF", padding: 5, fontSize: 12 }}>
                                                    {parseFloat(posting.amount).toLocaleString('en-US', {
                                                        minimumIntegerDigits: 1,
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })}
                                                </td>
                                                <td style={{ width: 20 }}></td>
                                                <td style={{ textAlign: "right", backgroundColor: "#90AAD666", padding: 5,  fontSize: 12 }}>
                                                    {parseFloat(posting.amount).toLocaleString('en-US', {
                                                        minimumIntegerDigits: 1,
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })}
                                                </td>
                                            </tr>
                                        ))}

                                      
                                        <tr>
                                            <td colSpan={2} style={{ fontWeight: 'bold', paddingLeft: 20, fontSize: 14 }} className={classes.totalTh}>
                                                TOTAL {category.description.toUpperCase()}
                                            </td>
                                            <td style={{
                                                textAlign: "right",
                                                fontWeight: 'bold',
                                                backgroundColor:  "#F2F7FF",
                                                padding: 5,
                                                fontSize: 12,
                                                borderTop: "1px solid black",
                                                borderBottom: "1px solid black"
                                            }}>
                                                {parseFloat(category.total).toLocaleString('en-US', {
                                                    minimumIntegerDigits: 1,
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                })}
                                            </td>
                                            <td></td>
                                            <td style={{
                                                textAlign: "right",
                                                fontWeight: 'bold',
                                                fontSize: 12,
                                                backgroundColor: "#90AAD666",
                                                padding: 5,
                                                borderTop: "1px solid black",
                                                borderBottom: "1px solid black"
                                            }}>
                                                {parseFloat(category.total).toLocaleString('en-US', {
                                                    minimumIntegerDigits: 1,
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                })}
                                            </td>
                                        </tr>
                                        <td style={{ width: 50 }}>&nbsp;&nbsp;&nbsp;</td>
                                    </React.Fragment>
                                ))}

                                <tr>
                                    <td colSpan={2} style={{ fontWeight: 'bold', paddingLeft: 20, fontSize: 14 }}>TOTAL {item.description.toUpperCase()}</td>
                                    <td style={{
                                        textAlign: "right",
                                        fontWeight: 'bold',
                                        backgroundColor: "#F2F7FF",
                                        padding: 5,
                                        fontSize: 12,
                                        borderTop: "2px solid black",
                                        borderBottom: "2px solid black"
                                    }}>
                                        {index === 0
                                            ? totalDebit.toLocaleString("en-US", {
                                                minimumIntegerDigits: 1,
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })
                                            : totalCredit.toLocaleString("en-US", {
                                                minimumIntegerDigits: 1,
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })}
                                    </td>
                                    <td></td>
                                    <td style={{
                                        textAlign: "right",
                                        fontWeight: 'bold',
                                        fontSize: 12,
                                        backgroundColor: "#90AAD666",
                                        padding: 5,
                                        borderTop: "2px solid black",
                                        borderBottom: "2px solid black"
                                    }}>
                                        {index === 0
                                            ? totalDebit.toLocaleString("en-US", {
                                                minimumIntegerDigits: 1,
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })
                                            : totalCredit.toLocaleString("en-US", {
                                                minimumIntegerDigits: 1,
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })}
                                    </td>
                                </tr>
                                <td style={{ width: 50 }}>&nbsp;&nbsp;&nbsp;</td>
                                <p></p>
                            </React.Fragment>
                        );
                    })}
                     <td style={{ width: 50 }}>&nbsp;&nbsp;&nbsp;</td>
                    <tr>
                        <td colSpan={2} style={{ fontWeight: 'bold', fontSize: 14 }} className={classes.totalTh}>
                            SURPLUS BEFORE DEPRECIATION AND FINANCE
                        </td>
                        <td style={{
                            textAlign: "right",
                            fontWeight: 'bold',
                            backgroundColor: "#F2F7FF",
                            padding: 5,
                            fontSize: 12,
                            borderTop: "1px solid black",
                            borderBottom: "1px solid black"
                        }}>
                            {parseFloat(overallTotal).toLocaleString('en-US', {
                                minimumIntegerDigits: 1,
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}
                        </td>
                        <td></td>
                        <td style={{
                            textAlign: "right",
                            fontWeight: 'bold',
                            backgroundColor: "#90AAD666",
                            padding: 5,
                            fontSize: 12,
                            borderTop: "1px solid black",
                            borderBottom: "1px solid black"
                        }}>
                            {parseFloat(overallTotal).toLocaleString('en-US', {
                                minimumIntegerDigits: 1,
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={2} style={{ fontWeight: 'bold' }} className={classes.totalTh}>
                            SURPLUS FOR THE PERIOD
                        </td>
                        <td style={{
                            textAlign: "right",
                            fontWeight: 'bold',
                            backgroundColor: "#F2F7FF",
                            padding: 5,
                            fontSize: 12,
                            borderTop: "1px solid black",
                            borderBottom: "1px solid black"
                        }}>
                            {parseFloat(overallTotal).toLocaleString('en-US', {
                                minimumIntegerDigits: 1,
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}
                        </td>
                        <td></td>
                        <td style={{
                            textAlign: "right",
                            fontWeight: 'bold',
                            backgroundColor: "#90AAD666",
                            padding: 5,
                            fontSize: 12,
                            borderTop: "1px solid black",
                            borderBottom: "1px solid black"
                        }}>
                            {parseFloat(overallTotal).toLocaleString('en-US', {
                                minimumIntegerDigits: 1,
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}
                        </td>
                    </tr>
                    </tbody> */}
                    <tbody style={{ whiteSpace: 'nowrap' }}>
                                          {accounts.map((item, index) => (
                                            <React.Fragment key={index}>
                                              <tr>
                                                <th style={{textDecoration: "underline", fontWeight: 'bold', fontSize: 14}} colSpan={100}>{item.description.toUpperCase()}</th>
                                              </tr>
                                              {item.categories?.map((category, catIndex) => (
                                                <React.Fragment key={catIndex}>
                                                  <tr>
                                                    <th style={{whiteSpace: "nowrap", paddingLeft: 15, fontSize: 14}} colSpan={100} >{category.description}</th>
                                                  </tr>
                                                  {category.postings.map((posting, postIndex) => (
                                                    <tr key={postIndex}>
                                                      <td style={{whiteSpace: "nowrap", paddingLeft: 26, fontSize: 14}}>{posting.name}</td>
                                                      <td></td>
                                                      <td></td>
                                                      <td style={{ textAlign: "right",  backgroundColor: "#F2F7FF", padding: 5,  fontSize: 14 }}>
                                                        {parseFloat(posting.amount).toLocaleString('en-US', {
                                                          minimumIntegerDigits: 1,
                                                          minimumFractionDigits: 2,
                                                          maximumFractionDigits: 2
                                                        })}
                                                      </td>
                                                      <td style={{width: 20}}></td>
                                                      <td style={{ textAlign: "right", backgroundColor: "#90AAD666", padding: 5, fontSize: 14 }}>
                                                        {parseFloat(posting.cAmount).toLocaleString('en-US', {
                                                          minimumIntegerDigits: 1,
                                                          minimumFractionDigits: 2,
                                                          maximumFractionDigits: 2
                                                        })}
                                                      </td>
                                                    </tr>
                                                  ))}
                                                  <tr>
                                                    <td colSpan={1} style={{ fontWeight: 'bold', whiteSpace: "nowrap", fontSize: 14 }}>Total </td>
                                                    <td></td>
                                                    <td></td>
                                                    <td style={{ textAlign: "right", backgroundColor: "#F2F7FF", padding: 5, borderTop: "2px solid black", borderBottom: "2px solid black", fontSize: 14 }} className={classes.totalTh}>
                                                      {parseFloat(category.total).toLocaleString('en-US', {
                                                        minimumIntegerDigits: 1,
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                      })}
                                                    </td>
                                                    <td style={{width: 50}}>&nbsp;&nbsp;&nbsp;</td>
                                                    <td  style={{textAlign: "right", backgroundColor: "#90AAD666", padding: 5, borderTop: "2px solid black", borderBottom: "2px solid black", fontSize: 14 }} className={classes.totalTh}>
                                                      {parseFloat(category.cTotal).toLocaleString('en-US', {
                                                        minimumIntegerDigits: 1,
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                      })}
                                                    </td>
                                                  </tr>
                                                  <tr><td colSpan={100}>&nbsp;</td></tr>
                                                </React.Fragment>
                                              ))}
                                            </React.Fragment>
                                          ))}
                                          {accounts?.length > 0 && (
                                          <tr>
                                            <td style={{ fontWeight: 'bold', fontSize: 14 }} >
                                              TOTAL {accounts[1]?.description.toUpperCase()} & {accounts[2]?.description.toUpperCase()}
                                            </td>
                                            <td></td>
                                            <td></td>
                                            <td style={{ fontSize: 14, textAlign: "right", fontWeight: 'bold', backgroundColor: "#F2F7FF", padding: 5, borderTop: "2px solid black", borderBottom: "2px solid black", }}>
                                              {totalCombined.toLocaleString('en-US', {
                                                minimumIntegerDigits: 1,
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2
                                              })}
                                            </td>
                                            <td></td>
                                            <td style={{fontSize: 14, textAlign: "right", fontWeight: 'bold',backgroundColor: "#90AAD666", padding: 5, borderTop: "2px solid black", borderBottom: "2px solid black", }}>
                                              {totalcCombined.toLocaleString('en-US', {
                                                minimumIntegerDigits: 1,
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2
                                              })}
                                            </td>
                                          </tr>
)}
                                        </tbody>
        </table>
         <div style={{marginTop: 30}}/>
        <h4 className={classes.btmPrg}>These Financial Statements were approved by the Governing Council at a meeting held on __________________ and were signed on its behalf by:</h4>
        <div className={classes.sigNatures}>
            <span>National Overseer</span>
            <span>National Treasurer</span>
        </div>
        

         


 </>
  )}
        </div>
     <div style={{ marginTop: 27 }} />
    {/* {accounts?.length > 0 && (
        <div className={classes.cardContainer}>
  {(() => {
    const openingBalance = parseFloat(accounts[0]?.opening_balance || 0);

    
    let totalDebit = 0;
    let totalCredit = 0;

    accounts.forEach((item) => {
      totalDebit += parseFloat(item.debit) || 0;
      totalCredit += parseFloat(item.credit) || 0;
    });

    const closingBalance = parseFloat(accounts[0]?.closing_balance || 0);

    const stats = [
      {
        label: "Opening Balance",
        value: openingBalance,
        labelColor: "#2563EB",
      },
      
      {
        label: "Total Debits",
        value: totalDebit,
        labelColor: "#EF4444",
      },
      {
        label: "Total Credits",
        value: totalCredit,
        labelColor: "#16A34A",
      },
      {
        label: "Closing Balance",
        value: closingBalance,
        labelColor: "#A855F7",
      },
    ];

    return stats.map((item, idx) => (
      <div className={classes.statCard} key={idx}>
        
        <h3 className={classes.cardValue}>
          <span style={{ color: item.labelColor }}>
            {item.value.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </span>
        </h3>

       
        <div className={classes.cardHeader}>
          <p className={classes.cardLabel}  style={{ color: item.labelColor }}>{item.label}</p>
        </div>
      </div>
    ));
  })()}
</div>
)} */}
      </div>
      {savingsLoading && (
        <div className={classes.overlay}>
          <img src={RotatingLogo} alt="Loading..." className={classes.spinnerLogo} />
        </div>
      )}

    </div>
  )
}

export default FinancialPositionDetailed
